import { GetAdminOverviewResponse } from '@orbit/api-types'
import { useAdminFilter } from '@pages/Admin/AdminFilterContext'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches the admin overview (GET /v1/admin/overview), scoped to the global
 * creation-date range from {@link useAdminFilter}. The range is part of the query
 * key, so changing it refetches. The endpoint is gated server-side by the
 * AdminGuard; non-admins receive 403.
 */
export const useAdminOverview = () => {
	const { from, to, includeInternal } = useAdminFilter()

	return useQuery<GetAdminOverviewResponse>({
		queryKey: queryKeys.adminOverview(from, to, includeInternal),
		queryFn: async () => {
			const response = await api.get<GetAdminOverviewResponse>('/admin/overview', {
				params: { from, to, includeInternal: includeInternal || undefined },
			})
			return response.data
		},
	})
}
